import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CountdownService {
  private countdownSource = new BehaviorSubject<number>(0);
  // eslint-disable-next-line @typescript-eslint/member-ordering
  countdown$ = this.countdownSource.asObservable();
  private countdownSubscription: Subscription;

  startCountdown(initialValue: number, intervalDuration: number = 1000, onCountdownEnd?: () => void): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }

    let remainingTime = initialValue;
    this.countdownSource.next(remainingTime);

    this.countdownSubscription = interval(intervalDuration)
      .pipe(takeWhile(() => remainingTime > 0))
      .subscribe(() => {
        remainingTime--;
        this.countdownSource.next(remainingTime);

        if (remainingTime === 0 && onCountdownEnd) {
          onCountdownEnd();
        }
      });
  }

  stopCountdown(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
}
